import { render, staticRenderFns } from "./TableRowV2.vue?vue&type=template&id=24234a70&scoped=true&"
import script from "./TableRowV2.vue?vue&type=script&lang=js&"
export * from "./TableRowV2.vue?vue&type=script&lang=js&"
import style0 from "./TableRowV2.vue?vue&type=style&index=0&id=24234a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24234a70",
  null
  
)

export default component.exports